// extracted by mini-css-extract-plugin
export default {"menuItem":"Menu_menuItem__tCZW8"};